import Games from "./Games";

const Home = (): JSX.Element => (
  <>
    <Games />
  </>
);

export default Home;
